"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PolicyCertificate_1 = require("../models/PolicyCertificate");
var mockPolicyCarData_1 = __importDefault(require("./mockPolicyCarData"));
var mockPolicyCertificate = __assign(__assign({}, PolicyCertificate_1.makeEmptyPolicyCertificate()), { carData: mockPolicyCarData_1.default });
exports.default = mockPolicyCertificate;
//# sourceMappingURL=mockPolicyCertificate.js.map